/**
 * Determine whether the supplied value is a “plain” object
 * (i.e. created with `{}` / `new Object()` and **not** an Array, Date, etc.).
 *
 * @param {*} value – anything
 * @returns {boolean} **true** when `value` is a non‑null object whose prototype is `Object.prototype`.
 */
const isPlainObject = (value) =>
  value !== null &&
  typeof value === 'object' &&
  Object.getPrototypeOf(value) === Object.prototype;

export default isPlainObject;
